import React from 'react'
import { WithContext as ReactTags } from 'react-tag-input';
import {NavLink} from 'react-router-dom';

export default function MyModalBody(props) {
  let authorName, date, textSectors, location, description;
  let tags = [];

  // Extracting data from props in here b/c otherwise it'll give me errors about null data on first render.
  if (props.modalData) {
    authorName = props.modalData.authorName;
    date = props.modalData.date.toDateString();
    date = date.substring(date.indexOf(" ") + 1);

    props.modalData.sector.forEach((sector, index) => {
      if (sector) {
        if (index === 0) {
          textSectors = sector;
        }
        else textSectors += `, ${sector}`;
      }
    });
    
    location = `${props.modalData.city}, ${props.modalData.region}, ${props.modalData.country}`;
    description = props.modalData.description;
    props.modalData.features.forEach(feature => {
      if (feature) tags.push({ id: `${feature}${Math.random()}`, text: feature});
    });
  }

  return (
      <div className="px-4 pb-4">
        <div className="modal-tags-section">
          <p className="modal-mini-heading pt-3"><strong>Posted by: </strong> 
          <NavLink to={`/users/${props.modalData.authorID}`}> {authorName}</NavLink>
          </p>
          <p className="modal-mini-heading"><strong>Date:</strong> {date}</p>
          <p className="modal-mini-heading"><strong>Sector:</strong> {textSectors}</p>
          <p className="modal-mini-heading"><strong>Location:</strong> {location}</p>
        </div>
      

        <h5 className="mt-5">Details</h5>
        <div className="modal-details-section pt-3">
          {description && 
          (<><p className="modal-mini-heading pt-2"><strong>Description:</strong></p>
          <p className="pb-4" style={{"borderBottom": "1px solid black"}}>{description}</p></>)
          }
          <p className="modal-mini-heading pt-3"><strong>Features Requested:</strong></p>
          <ReactTags tags={tags} readOnly={true}/>
          <br/>
        </div>
      </div>  );
}
